import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TeiasoftLoaderService {
  // Observable string sources
  private teiasoftLoaderStartSource = new Subject<any>();
  private stopTimeout: ReturnType<typeof setTimeout> | null = null;

  // Observable string streams
  teiasoftLoaderStart$ = this.teiasoftLoaderStartSource.asObservable();

  constructor() { }

  start() {
    if (this.stopTimeout) {
      clearTimeout(this.stopTimeout);
      this.stopTimeout = null;
    }
    this.teiasoftLoaderStartSource.next('show');
  }

  stop() {
    if (this.stopTimeout) {
      clearTimeout(this.stopTimeout);
    }
    this.stopTimeout = setTimeout(() => {
      this.teiasoftLoaderStartSource.next('stop');
      this.stopTimeout = null;
    }, 150);
  }
}
